import { Box, Typography } from "@mui/material";
import { useState } from "react";
import styles from "../../screens/InternalTracker/InternalTracker.module.css";
import { formatDate } from "../../utils/const";
import { PiFileTextThin } from "react-icons/pi";
import { PiMailboxLight } from "react-icons/pi";
import Checkbox from "@mui/material/Checkbox";
import { CiMobile3 } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
const MatchesResultPublicResume = ({
  name,
  job,
  location,
  work,
  skills,
  skills2,
  btn1,
  btn2,
  matches,
  res,
  setSubmisionRow,
  handleViewShow,
  toggleSelect,
  type,
  setType,
  getPreferLocationNames,
}) => {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [isExpanded, setIsExpanded] = useState(false);
  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Box className={styles.matches_resume_result}>
      <Box>
        <Typography
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0",
          }}
        >
          <Typography>
            <b>
              {name} - {work}
            </b>
          </Typography>
        </Typography>
        {/* <Typography style={{ alignSelf: "flex-end" }}>
          {" "}
          <b>{matches}</b>
        </Typography> */}
        <Typography>
          <b>
            Matches{" "}
            {res?.overall_match_percentage !== undefined
              ? Math.round(res?.overall_match_percentage)
              : 0}
            % | {formatDate(res?.created_at)}{" "}
          </b>
        </Typography>
      </Box>
      <Box sx={{ backgroundColor: "#fff !important" }}>
        <span>
          <Typography>
            <b>{job}</b>
          </Typography>
          <Typography>
            <b>
              {" "}
              {location},
              {res?.prefer_location !== undefined &&
                getPreferLocationNames(res?.prefer_location)}
            </b>
          </Typography>
          <Typography>
            <b>
              {" "}
              {res?.p_tax_team?.includes("full_Time")
                ? `Salary $${res?.rate}`
                : `Rate $${res?.rate}`}{" "}
              {res?.p_tax_team?.includes("full_Time") ? "Yearly" : "Hourly"}
            </b>
          </Typography>

          <Typography sx={{ display: "flex" }}>
            {" "}
            Excellency in skills:{" "}
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                paddingLeft: "5px",
              }}
            >
              {isExpanded ? <b>{skills2}</b> : <b>{skills}</b>}
            </span>
            <span style={{ marginLeft: "10px" }} onClick={handleExpandClick}>
              {isExpanded ? <IoIosArrowUp /> : <IoIosArrowDown />}
            </span>
          </Typography>
        </span>

        <span style={{ alignSelf: "flex-end" }}>
          {/* <span
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 10px 0 40px",
            }}
          >
            <Typography>
              <div
                style={{
                  backgroundColor: "#e1eaf0",
                  cursor: "pointer",
                  borderRadius: "3px ",
                }}
              >
                <PiFileTextThin style={{ fontSize: "17px" }} />
              </div>
            </Typography>
            <Typography>
              <div
                style={{
                  backgroundColor: "#e1eaf0",
                  cursor: "pointer",
                  borderRadius: "3px ",
                }}
              >
                <CiMobile3 style={{ fontSize: "17px" }} />
              </div>
            </Typography>
            <Typography>
              <div
                style={{
                  backgroundColor: "#e1eaf0",
                  cursor: "pointer",
                  borderRadius: "3px ",
                }}
              >
                <PiMailboxLight style={{ fontSize: "17px" }} />
              </div>
            </Typography>
          </span> */}
          <div
            style={{
              marginTop: "5px",
              backgroundColor: "white",
              display: "flex",
              alignItems: "end",
              justifyContent: "flex-end",
              flexDirection: "column",
            }}
          >
            <Checkbox
              {...label}
              checked={res?.selected === true}
              onChange={() => toggleSelect(res?.id)}
            />
            <button
              onClick={() => {
                handleViewShow();
                setSubmisionRow(res);
                setType(type);
                localStorage.setItem(
                  "internalCandidateDetails",
                  JSON.stringify({ row: res })
                );
              }}
              style={{ width: "auto" }}
            >
              {" "}
              {btn1}
            </button>
            {/* <button style={{ marginLeft: '10px' }}>{btn2}</button> */}
            {/* <Checkbox
              {...label}
              checked={res?.selected === true}
              onChange={() => toggleSelect(res?.id)}
            /> */}
          </div>
        </span>
      </Box>
    </Box>
  );
};

export default MatchesResultPublicResume;
